var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact_support_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 88.426,
    viewBox: "0 0 80 88.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M0,0H80V88.426H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M37.526,88.016V74.149C17.75,73.148,2,57.123,2,37.594,2,17.409,18.816,1,39.5,1S77,17.409,77,37.594c0,19.067-13.579,38.25-33.829,47.765ZM39.5,8.7C23.158,8.7,9.895,21.647,9.895,37.594S23.158,66.484,39.5,66.484h5.921v8.86c14.368-8.86,23.684-23.42,23.684-37.749C69.105,21.647,55.842,8.7,39.5,8.7ZM35.553,53h7.895v7.7H35.553Zm7.895-5.778H35.553c0-12.519,11.842-11.556,11.842-19.26a7.9,7.9,0,0,0-15.789,0H23.711a15.794,15.794,0,0,1,31.579,0C55.289,37.594,43.447,38.557,43.447,47.224Z",
    transform: "translate(0 0)",
    fill: "#2f68fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmAnswer);
export default __webpack_public_path__ + "static/media/confirm_answer.bef4af9003df375fd8dd6b87bcb80c45.svg";
export { ForwardRef as ReactComponent };